module.exports = __webpack_public_path__ + "static/img/Section2.84870f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Section2.png
// module id = 768
// module chunks = 0 8 10 11 12 13 14 15 16